module.exports = __webpack_public_path__ + "static/fonts/Helios.2668ac9.woff2";